


/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// REJECTSTAKENOWSECTION
// REJECTSTAKENOWSECTION


const REJECTSTAKENOWSECTION= createAsyncThunk(
  "rejectStakeNowSection/rejectStakeNowSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const rejectStakeNowSectionSlice = createSlice({
  name: "rejectStakeNowSectionSlice",
  initialState: {
    rejectStakeNowSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfrejectStakeNowSection: (state) => {
        state.rejectStakeNowSection.loading = false
        state.rejectStakeNowSection.error = false
        state.rejectStakeNowSection.data = []
        state.rejectStakeNowSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(REJECTSTAKENOWSECTION.fulfilled, (state, action) => {
      state.rejectStakeNowSection = {
        ...state.rejectStakeNowSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTSTAKENOWSECTION.pending, (state, action) => {
      state.rejectStakeNowSection = {
        ...state.rejectStakeNowSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTSTAKENOWSECTION.rejected, (state, action) => {
      state.rejectStakeNowSection = {
        ...state.rejectStakeNowSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const rejectStakeNowSectionAction = {
    REJECTSTAKENOWSECTION,
};

export { rejectStakeNowSectionAction };
export default rejectStakeNowSectionSlice.reducer;
export const {setInitialStateOfrejectStakeNowSection} = rejectStakeNowSectionSlice.actions
